export enum AssistVersion {
  NOT_ENABLED = 'NOT_ENABLED',
  LEGACY = 'LEGACY',
  SELF_SERVE = 'SELF_SERVE',
}

export const ASSIST_VERSION_LABELS: Record<AssistVersion, string> = {
  [AssistVersion.NOT_ENABLED]: 'Not enabled',
  [AssistVersion.LEGACY]: 'Assist 1.0',
  [AssistVersion.SELF_SERVE]: 'Assist 2.0',
};

export const ASSIST_MIGRATION_FLAG_KEYS = {
  SELF_SERVE_ASSIST: 'self-serve-assist',
  CALL_ASSISTANT_TOGGLE: 'call-assistant-toggle',
  RETELL_CONVERSATION_FLOW: 'isRetellAPIConversationFlow',
} as const;

export const ASSIST_MIGRATION_DEFAULT_FLAG_KEYS: string[] = Object.values(
  ASSIST_MIGRATION_FLAG_KEYS,
);

export const ASSIST_MIGRATION_SELF_SERVE_FILTER_FIELD =
  `ff_${ASSIST_MIGRATION_FLAG_KEYS.SELF_SERVE_ASSIST}` as const;
export const ASSIST_MIGRATION_ASSIST_ENABLED_FILTER_FIELD = 'bs_isAssistEnabled';

export const ASSIST_MIGRATION_DEFAULT_FILTERS: Record<string, string> = {
  [ASSIST_MIGRATION_ASSIST_ENABLED_FILTER_FIELD]: 'true',
  [ASSIST_MIGRATION_SELF_SERVE_FILTER_FIELD]: 'false',
};

export const ASSIST_MIGRATION_DEFAULT_BUSINESS_SETTINGS = ['isAssistEnabled'];

export const ASSIST_MIGRATION_DEFAULT_HIDDEN_COLUMNS = {
  isLaundroworksConnected: false,
  laundroworksCustomerCount: false,
} as const;
